/* Automatically generated by './build/bin/build-entry.js' */

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install)
}

import './static/self.less';

import dxxCard from './components/display/card.vue';
import dxxModal from './components/modal/modal.vue';
import dxxGrid from './components/table/grid.vue';
import dxxTable from './components/table/table.vue';
import dxxPager from './components/table/pager.vue';
import dxxTableColumn from './components/table/tableColumn.vue';
import dxxInput from './components/form/input.vue';
import dxxCheckbox from './components/form/checkbox.vue';
import dxxCheckboxGroup from './components/form/checkGroup.vue';
import dxxButton from './components/form/button.vue';
import dxxSelect from './components/form/select.vue';
import dxxOption from './components/form/selectOption.vue';
import dxxSwitch from './components/form/switch.vue';
import dxxTextarea from './components/form/textarea.vue';
import dxxRadio from './components/form/radio.vue';
import dxxRadioGroup from './components/form/radioGroup.vue';
import dxxForm from './components/form/form.vue';
import dxxFormItem from './components/form/formItem.vue';
import dxxComplete from './components/form/autoComplete.vue';
import dxxTreeSelect from './components/form/treeSelect.vue';
import dxxCascader from './components/form/cascader.vue';

const components = [
  dxxCard,
  dxxModal,
  dxxGrid,
  dxxTable,
  dxxPager,
  dxxTableColumn,
  dxxInput,
  dxxCheckbox,
  dxxCheckboxGroup,
  dxxButton,
  dxxSelect,
  dxxOption,
  dxxSwitch,
  dxxTextarea,
  dxxRadio,
  dxxRadioGroup,
  dxxForm,
  dxxFormItem,
  dxxComplete,
  dxxTreeSelect,
  dxxCascader
];

const install = function(Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

export default {
  version: '1.0.1',
  install,
  dxxCard,
  dxxModal,
  dxxGrid,
  dxxTable,
  dxxPager,
  dxxTableColumn,
  dxxInput,
  dxxCheckbox,
  dxxCheckboxGroup,
  dxxButton,
  dxxSelect,
  dxxOption,
  dxxSwitch,
  dxxTextarea,
  dxxRadio,
  dxxRadioGroup,
  dxxForm,
  dxxFormItem,
  dxxComplete,
  dxxTreeSelect,
  dxxCascader
};



// WEBPACK FOOTER //
// ./src/index.js